import { Component, OnInit, Type } from '@angular/core';
import { ProvinceFormComponent } from '../province-form/province-form.component';
import { BaseListComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component';
@Component({
  selector: 'ngx-province-list',
  templateUrl: './province-list.component.html',
  styleUrls: ['./province-list.component.scss']
})
export class ProvinceListComponent extends BaseListComponent {
  constructor() {
  super()
    this.inputEditorform = ProvinceFormComponent;
  }
  ngOnInit() {
    this.apiName= "Province";
    this.areaName="General";
    this.label = this.translate('ClientApp.GNR.Province.Province');
  }
}